import React from 'react';
import clsx from 'clsx';

import { Table } from 'wtb-components';
import { Block } from 'components';
import styles from './PurchaseBlock.module.css';

const PurchaseBlock = (props) => {
  const {
    className,
    title,
    collapsable,
    defaultExpanded,
    rows,
    itemsLabel,
    resultRows,
    resultLabel,
    totalRows,
    totalLabel,
    ...other
  } = props;

  return (
    <div className={clsx(styles.root, className)}>
      <Block
        title={title}
        collapsable={collapsable}
        defaultExpanded={defaultExpanded}
        headerBorder
        headerClass={styles.header}
        {...other}
      >
        <Table
          rows={rows.map((x) => ({ items: x }))}
          rowCellClassName={styles.purchaseInfoItemCell}
          rowDivider={false}
          aria-label={itemsLabel}
          headerDivider={false}
        />
      </Block>

      {resultRows.length ? (
        <div className={styles.resultsContainer}>
          <Table
            rows={resultRows.map((x) => ({ items: x }))}
            rowCellClassName={styles.tableCell}
            rowDivider={false}
            aria-label={resultLabel}
            headerDivider={false}
          />
        </div>
      ) : null}

      {totalRows.length ? (
        <div className={styles.resultsContainer}>
          <Table
            rows={totalRows.map((x) => ({ items: x }))}
            rowCellClassName={styles.tableCell}
            rowDivider={false}
            aria-label={totalLabel}
            headerDivider={false}
          />
        </div>
      ) : null}
    </div>
  );
};

export default PurchaseBlock;
